<template>
  <b-modal 
    :id="modalId" 
    :ref="modalId" 
    @shown="(isMultipleReports) ? selectedReport = reportsList[0] : selectedReport = null"
    hide-footer>
    <div class="modal-body">
      <b-row>
        <b-col cols="2" v-if="isMultipleReports">
          <h6>Select the report to print</h6>
          <b-button-group vertical>
            <b-button v-for="(report, i) in reportsList" :key="i" @click="selectedReport = report" 
              :variant="(selectedReport != null && selectedReport.reportName == report.reportName) ? 'primary' : 'outline-primary'">
              {{ report.text }}
            </b-button>
          </b-button-group>
        </b-col>
        <b-col :cols="isMultipleReports ? '10' : '12'">
          <wj-report-viewer :serviceUrl="serviceUrl" :filePath="filePathGenerator" :parameters="parameter" :reportName="reportNameGenerator" />
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    api: {
      type: String,
      default: 'api/report'
    },
    parameter: {
      type: Object,
      default: () => {}
    },
    modalId: {
      type: String,
      default: 'view-reports-modal'
    },
    reportsList: {
      type: Array,
      default: () => []
    },
    reportName: {
      type: String,
      default: ''
    },
    reportFileName: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      selectedReport: null,
      reportsRoot: 'ReportsRoot/'
    }
  },
  computed: {
    serviceUrl() {
      return process.env.VUE_APP_REPORT_URL + this.api;
    },
    isMultipleReports() {
      return (this.reportsList.length > 0);
    },
    filePathGenerator() {
      let name = (this.isMultipleReports && this.selectedReport) ? this.selectedReport.fileName : (this.reportFileName) ? this.reportFileName : this.reportName;

      return this.reportsRoot + name + '.flxr';
    },
    reportNameGenerator() {
      return (this.isMultipleReports && this.selectedReport) ? this.selectedReport.reportName : this.reportName;
    }
  }
}
</script>

<style>

</style>